import * as React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import theme from "../../../../components/styles/theme/theme";
import { isRegion } from "../../../../config";

export const EconomicImpactIntroduction: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography
        variant="body1"
        component="p"
        color={theme.palette.component["900"]}
        fontWeight="700"
        paddingLeft="16px"
      >
        {isRegion.latam
          ? t("common.select_region_title")
          : isRegion.usa
          ? t("common.select_state_title")
          : t("common.select_year_title")}
      </Typography>
    </Box>
  );
};
